import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';

import { AuthGuard } from '~/core/classes/auth/auth.guard';

//******************************************************************************
//  Core Pages
//******************************************************************************
import { AuthComponent } from '~/core/pages/auth/auth.component';
import { NotFoundComponent } from '~/core/pages/notfound/notfound.component';

//******************************************************************************
//  Core Components
//******************************************************************************
import { ErrorComponent } from '~/core/components/error/error.component';
import { AccessComponent } from '~/core/components/access/access.component';

export const routes: any[] = [
    {
        path: 'auth',
        component: AuthComponent,
        canActivate: [MsalGuard] // Uncommented MsalGuard for route protection
    },
    {
        path: 'notfound',
        component: NotFoundComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'access',
        component: AccessComponent
    },
    {
        path: 'error',
        component: ErrorComponent
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class CoreRouting { }
